/* eslint-disable max-len */
/* Note: this file is generated by "npm run template", please dont modify this file directly */
/* -- instead, you should modify "static-files/gant-legacy/README.md" and run "npm run template" */
import { ResultFile } from "@gant-lowcode/lowcode-types";

export default function getFile(): [string[], ResultFile] {
  return [
    ["."],
    {
      name: "README",
      ext: "md",
      content:
        "# umi project\n\n## Getting Started\n\nInstall dependencies,\n\n```bash\n$ yarn\n```\n\nStart the dev server,\n\n```bash\n$ yarn start\n```\n",
    },
  ];
}
